<template>
    <nav class="navbar navbar-expand-lg navbar-light bg-white border-bottom p-0 ">
        <div class="container">
            <a class="navbar-brand mr-0 mr-sm-3 d-flex active" :href="urlHome">
                <span class="logo align-self-center">
                    <img
                        :src="logoURL"
                        class="img-fluid"
                        :title="'Prefeitura de Belo Horizonte'"
                        alt="Logo Prefeitura de Belo Horizonte"
                    >
                </span>
                <span class="divisoria align-self-center mx-2"> | </span>
                <span class="sigla align-self-center">{{ sigla }} </span>
            </a>

            <button
                    v-if="itensMenu.length || Object.keys(usuario).length"
                    class="navbar-toggler"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#navbarSupportedContent"
                    aria-controls="navbarSupportedContent"
                    aria-expanded="false"
                    aria-label="Toggle navigation"
            >
                <span class="navbar-toggler-icon"/>
            </button>

            <div
                class="navbar-collapse w-100 order-3 collapse2 collapse"
                id="navbarSupportedContent"
            >
                <ul class="navbar-nav ms-auto mb-2 mb-lg-0">
                <slot name="before-items"></slot>

                <li v-for="item in itensMenu" :key="item.label" class="nav-item">
                    <piweb-menu-item
                        v-if="menuHasSubmenu(item)"
                        :menu="item"
                    ></piweb-menu-item>
                    <component
                        :is="linkType"
                        v-else
                        class="nav-link mt-2 mt-lg-0 py-1 py-lg-3"
                        aria-current="page"
                        :href="item.link ? item.link : '/#'"
                        :to="item.link ? item.link : '/#'"
                    >{{ item.label }}
                    </component>
                </li>

                <slot name="after-items"></slot>

                <piweb-menu-usuario
                    :usuario="usuario"
                    :fnLogout="fnLogout"
                    v-if="Object.keys(usuario).length"
                >
                    <template v-slot:after-nome-usuario>
                    <slot name="menu-usuario-after-nome-usuario"> </slot>
                    </template>
                    <template v-slot:before-logout>
                    <slot name="menu-usuario-before-logout"> </slot>
                    </template>
                </piweb-menu-usuario>

                <slot name="after-menu-usuario"></slot>
                </ul>
            </div>
        </div>
    </nav>
</template>


<script>
import PiwebMenuUsuario from "@prodabel/piweb-lib-vue/src/lib-components/piweb-topo/piweb-menu-usuario.vue";
import PiwebMenuItem from "@prodabel/piweb-lib-vue/src/lib-components/piweb-topo/piweb-menu-item.vue";

export default {
    name: "MenuTopo",
    components: { PiwebMenuUsuario, PiwebMenuItem},
    props: {
        logoURL: {
            type: String,
            default: ""
        },
        sigla: {
            type: String,
            default: ""
        },
        itensMenu: {
            type: Array,
            default: () => []
        },
        usuario: {
            type: Object,
            default: () => {
            }
        },
        logoutCallback: {
            type: Function,
            default: () => {
            }
        },
        urlHome: {
            type: String,
            default: "login"
        }
    },
    methods:{
        menuHasSubmenu(menu) {
            return Object.keys(menu).includes("subitens");
        },

        fnLogout(){
            this.$emit('fnLogout')
        } 
    }
};
</script>

<style scoped>
  .navbar-brand .logo {
    width: 11rem;  
  }
    
  .navbar-collapse {
    justify-content: end;
  }

  @media (max-width: 576px) {
    .navbar-brand .logo {
        width: 7rem;  
    }    
  }

</style>